// extracted by mini-css-extract-plugin
export default {"cls1":"_hgwJDimcgPPEYljrtQZ","cls2":"U851RqsUlMYXVLoXlbCV _hgwJDimcgPPEYljrtQZ","isPhone":"yztpjN5Z6HbuBAWImVt4","sizeLarge":"pIwwOUBvVWjGfWO2banD"};